import React from "react";
import Sandbox from "./components/Sandbox/Sandbox";
import Header from "./components/Header/Header";

function App() {
  return (
    <React.Fragment>
      <Header title="Ankerplatform Sandbox" />
      <Sandbox />
    </React.Fragment>
  );
}

export default App;
